module.exports = __webpack_public_path__ + "static/media/user-1.eee09c38.svg";